import { render, staticRenderFns } from "./WarnMessage.vue?vue&type=template&id=604f12a8&scoped=true"
import script from "./WarnMessage.vue?vue&type=script&lang=js"
export * from "./WarnMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f12a8",
  null
  
)

export default component.exports